import type { BlockId, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import { useEffect } from 'react';
import { BlockLifecycleStatus, useGlobalStateStore } from '../stores/GlobalStateStore';
import { isEmptyBlock } from '../utils/block';
import { COMPONENT_TYPES_WITH_AGGREGATION_METADATA } from '../components/DataSourceController/components/AggregationMetadataHandler/utils';

export default function useSetBlockLifecycle(
  blockId: BlockId,
  componentType: ComponentTypeUnionType,
) {
  const { setBlockLifecycle } = useGlobalStateStore().use.actions();

  useEffect(() => {
    if (isEmptyBlock(blockId)) return;

    // if the block is a component that has aggregation metadata, we need to set the lifecycle to staging
    // this is because lifecycle is not used for any other use case currently
    // perf optimisation - to reduce the number of times the lifecycle is set
    // if a use case comes to track for all the blocks, then we need to uplift the staging code at top level so that setting the lifecycle is less frequent
    if (COMPONENT_TYPES_WITH_AGGREGATION_METADATA.has(componentType)) {
      setBlockLifecycle(blockId, BlockLifecycleStatus.Staging);
    }

    return () => {
      if (COMPONENT_TYPES_WITH_AGGREGATION_METADATA.has(componentType)) {
        setBlockLifecycle(blockId, BlockLifecycleStatus.Unmounted);
      }
    };
  }, [blockId, componentType, setBlockLifecycle]);
}
